import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";

function list(params) {
  const newParams = { ...params };
  if (newParams.max) {
    newParams.take = newParams.max;
    delete newParams.max;
  }
  if (newParams.offset) {
    newParams.skip = newParams.offset;
    delete newParams.offset;
  }

  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }

  const url = `/subscription-approval?${qsParams.toString()}`;
  ENABLE_API_DBG && console.log(`api.subscription-approval.list: url = ${url}`);

  return request({
    url,
    method: "get",
    data: newParams,
  });
}

function setSubsAppr(id, params) {
  const url = `/subscription-approval/${id}`;
  ENABLE_API_DBG && console.log(`api.setSubsAppr: url = ${url}, params = ${JSON.stringify(params)}`);

  return request({
    url,
    method: "patch",
    data: params,
  });
}



export default {
  list,
  setSubsAppr,
};
